import OneTimePasswordContainer from '../pages/register/OneTimePasswordContainer';
import ErrorScreen from '../pages/ErrorScreen';
import ResetPasswordPage from '../pages/register/reset-password';
import VerifyEmailPage from '../pages/register/VerifyEmail';
import UnifiedLoginContainer from '../pages/register/UnifiedLoginContainer';

export const registrationPaths = {
  login: '/register/login',
  loginVerify: '/register/login/verify',
  passwordReset: '/register/password-reset',
  verifyEmail: '/register/verify-email',
  error: '/register/error',
};

export const registrationRoutes = [
  {
    path: registrationPaths.login,
    component: UnifiedLoginContainer,
    protected: false,
    deeplinkPath: registrationPaths.login,
  },
  {
    path: registrationPaths.loginVerify,
    component: OneTimePasswordContainer,
    protected: false,
    deeplinkPath: registrationPaths.loginVerify,
  },
  {
    path: registrationPaths.error,
    component: ErrorScreen,
    protected: false,
    deeplinkPath: null,
  },
  {
    path: registrationPaths.passwordReset,
    component: ResetPasswordPage,
    protected: false,
    deeplinkPath: registrationPaths.passwordReset,
  },
  {
    path: registrationPaths.verifyEmail,
    component: VerifyEmailPage,
    protected: false,
    deeplinkPath: registrationPaths.verifyEmail,
  },
];
